<template>
	<div class="">
		<base-page-heading
			title="Discount new"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="createNewDiscount"
				>
					<i class="fa fa-fw fa-plus" /> 	Save Campaign
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<CreateDiscountTable
				ref="createDiscountTable"
			/>
		</div>
	</div>
</template>
